import React from 'react';

import { useFormContext } from 'react-hook-form';

import { LbInput, ReadOnlyInput, InputAdornment } from '@infoods/lifebase-ui';
import classes from './MealRow.module.scss';
import { Nutrient } from '../../../../shared/components/ui-components';
import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';
import { NUTRIENTS_ENUM } from '../../../../shared/constants/NUTRIENTS_ENUM';
import { processMealName } from '../../../../shared/utils/mealUtils';
import { RegularMealName, WorkoutMealName } from '../../../../shared/constants/mealNames';
import { MealPlansMacrosFormValues } from '../../../interfaces/MealPlan';
import { useMealCalories } from '../../../hooks/meal-plan-macros';
import { MACRO_INPUT_RULES } from '../../../constants/mealPlanMacros';

type MealRowProps = {
  meal: RegularMealName | WorkoutMealName;
  mealFormKey: `mealPlans.${number}.${RegularMealName}` | WorkoutMealName;
  isEditMode: boolean;
};

const nutrientsList = [
  NUTRIENTS_ENUM.PROTEINS,
  NUTRIENTS_ENUM.CARBS,
  NUTRIENTS_ENUM.FATS,
] as const;

const MealRow = ({ meal, mealFormKey, isEditMode }: MealRowProps) => {
  const { control } = useFormContext<MealPlansMacrosFormValues>();

  const nutrientsInputsSetting = nutrientsList.map(
    (nutrient) =>
      ({
        name: `${mealFormKey}.${nutrient}`,
        nutrient,
      }) as const,
  );

  const calories = useMealCalories(mealFormKey);

  return (
    <GridTableRow variant="unstyled" className={classes.row}>
      <GridTableCell variant="title">{processMealName(meal)}</GridTableCell>
      {nutrientsInputsSetting.map(({ name, nutrient }) =>
        isEditMode ? (
          <GridTableCell className={classes.cell} key={nutrient}>
            <LbInput
              control={control}
              name={name}
              size="small"
              type="number"
              rules={MACRO_INPUT_RULES}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Nutrient nutrient={nutrient} />
                  </InputAdornment>
                ),
              }}
            />
          </GridTableCell>
        ) : (
          <GridTableCell key={nutrient}>
            <Nutrient nutrient={nutrient}>
              <ReadOnlyInput control={control} name={name} helperText={null} />
            </Nutrient>
          </GridTableCell>
        ),
      )}

      <GridTableCell>
        <Nutrient nutrient="calories">
          <ReadOnlyInput
            control={control}
            name={`${mealFormKey}.calories`}
            value={calories}
          />
        </Nutrient>
      </GridTableCell>
    </GridTableRow>
  );
};

export { MealRow };
